import React, { useState } from "react";
import MobileHeader from '../components/layoutParts/mobile/MobileHeader';
import Footer from '../components/layoutParts/Footer';
import BottomFixedNav from '../components/mobileComponents/BottomFixedNav';
import { BiChevronDown, BiChevronUp } from "react-icons/bi";
import NavTop from "../components/layoutParts/NavTop";
import { useGlobal } from "../global/GlobalContext";

const MobileMainLayout = ({ children, title, ProductsCount, link }) => {
    const [showMenu, setShowMenu] = useState(false);
    const { accessoriesCat, menCat, womenCat, loadingCategories } = useGlobal();
    return (
        <>
            <div className="md:hidden block">
                <MobileHeader ProductsCount={ProductsCount} title={title} link={link}/>
            </div>
            <div className="hidden md:block">
                <NavTop />
            </div>
            <div>
                {children}
            </div>
            <div className="block md:hidden">
                <div className="bg-brand-600 p-4 text-white font-medium border-b flex justify-between text-base" onClick={() => setShowMenu(!showMenu)}>
                    <span>More About MPI</span>
                    <span className="text-2xl">
                        {showMenu ? <BiChevronUp /> : <BiChevronDown />}
                    </span>
                </div>
                <div>
                    {showMenu && (
                        <Footer
                            accessoriesCat={accessoriesCat}
                            menCat={menCat}
                            womenCat={womenCat}
                            loading={loadingCategories}
                        />
                    )}
                </div>
            </div>
            <div className="hidden md:block">
                <Footer
                    accessoriesCat={accessoriesCat}
                    menCat={menCat}
                    womenCat={womenCat}
                    loading={loadingCategories}
                />
            </div>

            {/* Reserves space so the fixed bottom nav below doesn't cover the last row of content */}
            <div className="h-16 md:hidden" />
            <BottomFixedNav />
        </>
    )
}

export default MobileMainLayout;